// Auto-generated by scripts/generate-branding-from-env.js — do not edit
export function applyBuildTimeBrandingFlags() {
  if (typeof document === 'undefined' || !document.documentElement) {
    return;
  }
  document.documentElement.removeAttribute('data-white-primary');
}
